// Production: Use environment variable or api.repairro domain
// Development: Falls back to localhost
const isDev = process.env.NODE_ENV === "development";

let backendUrl;

if (isDev) {
  // Development: Check if running on localhost
  const isLocalhost =
    typeof window !== "undefined" &&
    ["localhost", "127.0.0.1"].includes(window.location.hostname);
  backendUrl = isLocalhost ? "http://localhost:8000" : "https://api.servtek.nexitytec.cloud";
} else {
  // Production: MUST use environment variable
  backendUrl = process.env.REACT_APP_API_BASE_URL || "https://api.servtek.nexitytec.cloud";
}

backendUrl = backendUrl.replace(/\/+$/, "");

console.log("🔧 API Configuration:", {
  backendUrl,
  NODE_ENV: process.env.NODE_ENV,
  isDev,
  envVar: process.env.REACT_APP_API_BASE_URL,
});

export const API = `${backendUrl}/api`;